import { useQuery } from "@tanstack/react-query";
import {
  queryOrganizerByID,
  queryOrganizerByNumericID,
} from "supabase/organizers";

type UseQueryOrganizerParams = {
  uid?: string;
  id?: number;
};

export const useQueryOrganizer = (params: UseQueryOrganizerParams) => {
  const { uid, id } = params;

  const queryKey = uid ? ["organizer", uid] : ["organizer", `id:${id}`];

  const {
    isLoading,
    isError,
    error,
    data: organizer,
  } = useQuery({
    queryKey,
    queryFn: () => {
      if (uid) {
        return queryOrganizerByID({ uid });
      } else if (id) {
        return queryOrganizerByNumericID({ id });
      }
      throw new Error("Either uid or id must be provided");
    },
    enabled: !!uid || !!id,
  });

  return { isLoading, isError, error, organizer };
};
